import type { CircuitKindOptionItem } from './riso-measurement-types';

export const circuitKindOptions: CircuitKindOptionItem[] = [
    // { value: 'L-PE', label: 'L-PE', powerPhase: '3' },
    { value: 'N-PE', label: 'N-PE', powerPhase: '3' },
    { value: 'L1-PE', label: 'L1-PE', powerPhase: '3' },
    { value: 'L2-PE', label: 'L2-PE', powerPhase: '3' },
    { value: 'L3-PE', label: 'L3-PE', powerPhase: '3' },
    { value: 'L1-N', label: 'L1-N', powerPhase: '3' },
    { value: 'L2-N', label: 'L2-N', powerPhase: '3' },
    { value: 'L3-N', label: 'L3-N', powerPhase: '3' },
    { value: 'L1-L2', label: 'L1-L2', powerPhase: '3' },
    { value: 'L1-L3', label: 'L1-L3', powerPhase: '3' },
    { value: 'L2-L3', label: 'L2-L3', powerPhase: '3' },
];
